<template>
  <div class="drawer-content">
    <a-drawer
      :width="750"
      @close="rightDrawerClose"
      :visible="drawerVisibleFlag"
    >
      <div slot="title">
        {{ drawerTitle }}
      </div>
      <a-form layout="inline" class="drawForm">
        <a-form-item
          :label-col="{ span: 12 }"
          :wrapper-col="{ span: 12 }"
          label="测算份数："
        >
          <a-input-number
            :min="1"
            placeholder="请输入测算份数"
            v-model="menuCount"
          />
        </a-form-item>
        <a-form-item
          :label-col="{ span: 12 }"
          :wrapper-col="{ span: 12 }"
          label="单份重量："
        >
          <a-input placeholder="请输入单份的重量" v-model="menuWeight">
            <span
              slot="suffix"
              style="color:#999;position: relative;top: -4px;"
            >
              g
            </span>
          </a-input>
        </a-form-item>
      </a-form>
      <!-- content -->
      <a-table
        :columns="columns"
        :dataSource="drawerFoodListData"
        :pagination="false"
        :loading="tableLoading"
      >
        <template
          v-for="(col, i) in ['name', 'weight']"
          :slot="col"
          slot-scope="text, record"
        >
          <!-- table -->
          <template v-if="col === 'name'">
            <food-select
              :key="col"
              v-if="record.editable"
              :defaultValue="foodSelectDDefaaultVal"
              @select="handleFoodSelect(record.key, arguments)"
            ></food-select>
            <template v-else>{{ text }}</template>
          </template>
          <template v-else-if="col === 'weight'">
            <a-input
              :key="col"
              v-if="record.editable"
              style="margin: -5px 0"
              :value="text"
              :placeholder="columns[i].title"
              @change="e => handleWeightChange(e.target.value, record.key, col)"
            />
            <template v-else>{{ text }}</template>
          </template>
        </template>
        <template slot="operation" slot-scope="text, record">
          <template v-if="record.editable">
            <span v-if="record.isNew">
              <a @click="saveRow(record)">添加</a>
              <a-divider type="vertical" />
              <a-popconfirm
                title="是否要删除此行？"
                @confirm="removeRow(record)"
              >
                <a>删除</a>
              </a-popconfirm>
            </span>
            <span v-else>
              <a @click="saveRow(record)">保存</a>
              <a-divider type="vertical" />
              <a @click="cancel(record.key)">取消</a>
            </span>
          </template>
          <span v-else>
            <a @click="editRow(record)">编辑</a>
            <a-divider type="vertical" />
            <a-popconfirm title="是否要删除此行？" @confirm="removeRow(record)">
              <a>删除</a>
            </a-popconfirm>
          </span>
        </template>
      </a-table>
      <a-button
        style="width: 100%; margin-top: 16px; margin-bottom: 8px"
        type="dashed"
        icon="plus"
        @click="newPublishFood"
        >新增食材</a-button
      >
      <!-- footer -->
      <div
        :style="{
          position: 'absolute',
          left: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right'
        }"
      >
        <a-button :style="{ marginRight: '8px' }" @click="rightDrawerClose">
          取消
        </a-button>
        <a-button
          type="primary"
          @click="rightDrawSubmit"
          :loading="rightDrawSubmitLoading"
          >提交</a-button
        >
      </div>
    </a-drawer>
  </div>
</template>

<script>
import foodSelect from "./tpl/select-food";
import { MenuFoodTest, AddMenuFood, GetMenuFoods } from '@/apis/menu';
import { arrIsRepeat } from "@/utils/base"

const columns = [{
  title: '#',
  dataIndex: 'index',
  key: 'index',
  width: '60px',
  scopedSlots: { customRender: 'index' }
}, {
  title: '食材名称',
  dataIndex: 'name',
  key: 'name',
  width: '150px',
  scopedSlots: { customRender: 'name' }
},
{
  title: '编号',
  dataIndex: 'number',
  key: 'number',
  width: '100px'
},
{
  title: '重量/g',
  dataIndex: 'weight',
  key: 'weight',
  width: '100px',
  scopedSlots: { customRender: 'weight' }
},
{
  title: '操作',
  key: 'action',
  width: '110px',
  scopedSlots: { customRender: 'operation' }
}]


export default {
  data() {
    return {
      columns,
      drawerTitle: '添加食材',
      tableLoading: false,
      foodSelectDDefaaultVal: '',
      rightDrawSubmitLoading: false,
      drawerFoodListData: [],
      menuCount: 1,
      serverMenuWeight: 0,
      menuWeight: 0
    }
  },
  props: {
    drawerVisibleFlag: {
      type: Boolean,
      default: false
    },
    menuId: {
      type: Number
    },
    isFoodComponent: {
      type: Boolean,
      default: false
    },
    isNutrion: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    calcMenuWeight() {
      const totalWeight = this.drawerFoodListData.reduce((total, item) => (total * 100 + Number(item.weight) * 100) / 100, 0)
      return (totalWeight / this.menuCount).toFixed(2)
    },
    _getFoodList() {
      this.tableLoading = true
      GetMenuFoods({
        id: this.menuId
      }).then(res => {
        const result = res.data.attribute
        if (result.length) {
          this.menuCount = result[0].count
          this.menuWeight = result[0].menuWeight
          result.map((item, index) => {
            this.drawerFoodListData.push({
              key: (index + 1).toString(),
              index: index + 1,
              foodId: item.componentId,
              name: item.foodName,
              number: item.foodCode,
              weight: item.weight,
              isNew: false,
              editable: false
            })
          })
          this.tableLoading = false
        }
      })
    },
    // 关闭右侧抽屉
    rightDrawerClose() {
      this.drawerFoodListData = []
      this.$emit('close')
    },
    // 新增一条Item
    newPublishFood() {
      const length = this.drawerFoodListData.length
      this.drawerFoodListData.push({
        key: length === 0 ? '1' : (parseInt(this.drawerFoodListData[length - 1].key) + 1).toString(),
        index: length === 0 ? 1 : (parseInt(this.drawerFoodListData[length - 1].key) + 1),
        foodId: 0,
        name: '',
        number: '******',
        weight: 0,
        isNew: true,
        editable: true
      })
      this.foodSelectDDefaaultVal = ''
    },
    // 删除item
    removeRow(record) {
      const key = record.key
      let newData = this.drawerFoodListData.filter(item => item.key !== key)
      this.handleArrayIndexNumber(newData)
      this.drawerFoodListData = newData
      this.menuWeight = this.calcMenuWeight()
    },
    handleArrayIndexNumber(arr) {
      arr.forEach((item, index) => {
        item.index = index + 1
      })
    },
    // 保存item
    saveRow(record) {
      const { key, name, weight } = record
      if (!name || !weight) {
        this.$message.warning('请填写完整信息！')
        return
      }
      if (!/(^[0-9](\d+)?(\.\d{1,3})?$)|(^\d\.\d{1,3}$)/.test(weight)) {
        this.$message.warning('重量格式不正确！')
        return
      }

      let that = this;
      function _callBack() {
        const target = that.drawerFoodListData.filter(item => item.key === key)[0]
        target.editable = false
        target.isNew = false
      }
      _callBack()

      this.menuWeight = this.calcMenuWeight()
    },
    // 保存或编辑
    editRow(record) {
      this.foodSelectDDefaaultVal = record.name
      const target = this.drawerFoodListData.filter(item => item.key === record.key)[0]
      target.editable = !target.editable
    },
    getRowByKey(key, newData) {
      const data = this.drawerFoodListData
      return (newData || data).filter(item => item.key === key)[0]
    },
    // 取消
    cancel(key) {
      const target = this.drawerFoodListData.filter(item => item.key === key)[0]
      target.editable = false
    },
    // 处理
    handleWeightChange(value, key, column) {
      const newData = [...this.drawerFoodListData]
      const target = newData.filter(item => key === item.key)[0]
      if (target) {
        target[column] = value
        this.drawerFoodListData = newData
      }
    },
    // 菜品下拉选中
    handleFoodSelect(key, args) {
      const item = args[0]
      const currentEditObj = this.drawerFoodListData[this.drawerFoodListData.findIndex((value) => { return value.key === key })]
      currentEditObj.name = item.food_Name
      currentEditObj.foodId = item.food_Id
      currentEditObj.number = item.food_Code
    },
    // 发布菜单提交
    rightDrawSubmit() {
      if (this.drawerFoodListData.length === 0) {
        this.$message.warning("请先添加食材")
      } else {
        const errorData = this.drawerFoodListData.filter(item => item.isNew || item.editable)
        if (errorData.length) {
          this.$message.warning("请先完成食材的添加与修改")
          return
        }

        let data = {
          id: this.menuId,
          count: this.menuCount,
          weight: this.menuWeight * this.menuCount,
          list: []
        }
        const tempFoodIds = [] // 接收foodId
        this.drawerFoodListData.forEach((item) => {
          tempFoodIds.push(item.foodId)
          data.list.push({
            id: item.foodId,
            weight: item.weight
          })
        })
        if (arrIsRepeat(tempFoodIds)) {
          this.$message.warning("列表中包含相同食材，请检查后再提交")
          return
        }
        this.rightDrawSubmitLoading = true
        console.log();

        const that = this
        const submitFn = () => {
          AddMenuFood({
            list: JSON.stringify(data)
          }).then(res => {
            that.rightDrawSubmitLoading = false
            if (res.data.state === 1) {
              that.$message.success('提交成功')
              that.$emit("rightDrawSubmit")
              that.drawerFoodListData = []
            }
          }, res => {
            that.rightDrawSubmitLoading = false
          })
        }

        if (that.isNutrion) {
          // 如果是营养菜
          MenuFoodTest({
            list: JSON.stringify(data)
          }).then(res => {
            const result = res.data.attribute
            let message = ''
            if (result.state === 1) {
              message = (<div style="color: #1890ff;">您添加的食物成分符合平衡膳食指标!</div>)
            } else if (result.state === 2) {
              message = (<div>
                {result.reasonList.map(item => {
                  return (<div style="color: #fa8c16;border-color: #ffd591; margin:5px 0;">{item}</div>)
                })
                }
              </div>)
            }
            that.$confirm({
              title: '您确定要提交菜品食物成分吗？',
              content: message,
              onCancel() {
                that.rightDrawSubmitLoading = false
              },
              onOk() {
                if (result.state === 1) {
                  submitFn()
                } else if (result.state === 2) {
                  that.$message.warning('请按照系统建议修改菜品食物成分。')
                  that.rightDrawSubmitLoading = false
                }
              }
            });
          })
        } else {
          // 如果是传统菜
          that.$confirm({
            title: '您确定要提交菜品食物成分吗？',
            onCancel() {
              that.rightDrawSubmitLoading = false
            },
            onOk() {
              submitFn()
            }
          });
        }
      }
    }

  },
  components: {
    foodSelect
  },
  watch: {
    isFoodComponent: function (data) {
      if (data) {
        this.drawerTitle = '修改食材'
        this._getFoodList()
      } else {
        this.drawerTitle = '添加食材'
        this.drawerFoodListData = []
      }
    },
    menuCount(newVal) {
      if (newVal) {
        this.menuWeight = this.calcMenuWeight()
      }
    }
  }
}
</script>

<style lang="less">
.ant-drawer-body {
  max-height: calc(100% - 108px);
  overflow-y: scroll;
}

.drawForm /deep/ .ant-row.ant-form-item {
  margin-bottom: 5px;
}
</style>